import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from '@Root/slices'
import { changePopup } from '@Root/slices/popup/alarmPopup'
import { POPUP_TYPE } from '@Root/contants/popup'

export default function usePopup() {
  const dispatch = useDispatch()
  const popup = useSelector((state: RootState) => state.popup)

  const changePopupData = useCallback(
    (param: { key: POPUP_TYPE }) => {
      dispatch(changePopup(param))
    },
    [dispatch],
  )

  const changeInit = useCallback(() => {
    dispatch(changePopup({ key: POPUP_TYPE.NONE }))
  }, [dispatch])

  return {
    popup,
    changePopupData,
    changeInit,
  }
}
